import { ElementRef } from '@angular/core';

//Setting overflow to hidden to ensure no scrollbar appear on custom grid
export function setOverFlowHiddenOnBodyTag() {
  const body = document.getElementById('web-app');
  if (body) {
    body.style.overflow = 'hidden';
  }
}

export function setOverFlowAutoOnBodyTag() {
  const body = document.getElementById('web-app');
  if (body) {
    body.style.overflow = 'auto';
  }
}

// The offsets shrink the container below its content height so a scroll event fires
// before the user reaches the bottom, triggering infinite-scroll pagination early.
// Pass 0 for lists that don't paginate on scroll, so the container isn't clipped.
export function scrollLoading(
  id: string,
  eleRef: ElementRef<any>,
  scrollHeightOffset = 100,
  offsetTopOffset = 150,
): string {
  const section = eleRef.nativeElement.closest('section') as HTMLElement;
  const sectionMaxHeight = section?.style?.maxHeight;
  const sectionHeight = section?.style?.height;
  const element = document.getElementById(id);

  let elementHeight: string;

  if (element) {
    if (element.scrollHeight > 0) {
      elementHeight = element.scrollHeight - scrollHeightOffset + 'px';
    } else if (element.offsetTop > 0) {
      elementHeight = element.offsetTop - offsetTopOffset + 'px';
    } else {
      elementHeight = '400px';
    }
  } else {
    elementHeight = '400px';
  }

  // Prefer section maxHeight, then height, then fallback elementHeight
  return sectionMaxHeight || sectionHeight || elementHeight;
}
